import ko from "knockout";
import { Dictionary } from "flow/api/types";
import { MaybeObservable } from "flow/interfaces/MaybeObservable";

export function interceptAttributesWithDefaults(
    defaults: Dictionary,
    attr: MaybeObservable<Dictionary<MaybeObservable<any>>>
): KnockoutObservable<Dictionary<MaybeObservable<any>>> {
    return ko.pureComputed(() => {
        const userAttr = ko.unwrap(attr);
        const mergedAttr = {
            ...defaults,
            ...userAttr
        };
        return mergedAttr;
    });
}

export function interceptAttributesWithDefaultsIgnoreId(
    defaults: Dictionary,
    attr: MaybeObservable<Dictionary<MaybeObservable<any>>>
): KnockoutObservable<Dictionary<MaybeObservable<any>>> {
    return ko.pureComputed(() => {
        const userAttr = ko.unwrap(attr);
        const mergedAttr = {
            ...defaults,
            ...userAttr
        };
        if (mergedAttr.id) {
            delete mergedAttr.id;
        }
        return mergedAttr;
    });
}
